
    // IMPORTS
    import { defineComponent, PropType } from 'vue'

    import TopBanner from '@/components/top-banner.vue'
    import { INavigationItem } from '@/types/INavigationItem'

    export default defineComponent({
        name: 'portalPage',

        components: {
            TopBanner
        },

        props: {
            title: { type: String as PropType<string | null>, required: false, default: () => null },
            showBackButton: { type: Boolean as PropType<boolean>, required: false, default: () => false },
            showLogOff: { type: Boolean as PropType<boolean>, required: false, default: () => false },
            navigationItems: { type: Array as PropType<INavigationItem[]>, required: false, default: () => [] },
            container: { type: String as PropType<'main' | 'admin'>, required: false, default: () => 'main' }
        },

        setup() {
            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return {}
        }
    })
